import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

export const fadeInUpAnimation =
    trigger('fadeInUp', [
        // Enter transition
      transition(':enter', [
          // styles at start of transition
        style({ opacity: 0 }),
        // animation and styles at end of transition
        animate('1s 0.7s', keyframes([
          style({ opacity: 0, transform: 'translate3d(0, 100%, 0)' }),
          style({ opacity: 1, transform: 'none' })
        ]))
      ])
    ])


// WEBPACK FOOTER //
// ./src/app/shared/animations/fadeInUp.animation.ts